import { render, staticRenderFns } from "./DepartTransferModal.vue?vue&type=template&id=5ffde000&scoped=true&"
import script from "./DepartTransferModal.vue?vue&type=script&lang=js&"
export * from "./DepartTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffde000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffde000')) {
      api.createRecord('5ffde000', component.options)
    } else {
      api.reload('5ffde000', component.options)
    }
    module.hot.accept("./DepartTransferModal.vue?vue&type=template&id=5ffde000&scoped=true&", function () {
      api.rerender('5ffde000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DepartTransferModal.vue"
export default component.exports